<template>
  <HeroCanvasBackground
    :color-mode="colorMode"
    :effect-opacity="colorMode === 'light' ? 1 : 0"
  />
</template>

<script setup lang="ts">
import { HeroCanvasBackground } from '@hypercodestudio/basler-components';

/**
 * We only render the animation on client side for now, as we can not
 * set color mode dynamically inside layout components.
 *
 * @see https://gcp.baslerweb.com/jira/browse/WEB2-2412
 */
const colorMode = useInjectedColorMode();
</script>
